import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { ISearchSuggestion } from '@app/shared/services/image-analysis.service';

@Component({
	selector: 'au-ai-search-suggestions',
	templateUrl: './ai-search-suggestions.component.html',
	styleUrls: ['./ai-search-suggestions.component.scss'],
	imports: [CommonModule, MatChipsModule, MatIconModule, NgxTolgeeModule],
})
export class AiSearchSuggestionsComponent {
	searchSuggestions = input<ISearchSuggestion[]>([]);

	openSuggestionInNewTab(url: string): void {
		if (url) {
			window.open(url, '_blank', 'noopener,noreferrer');
		}
	}
}
